import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {Store} from '@ngrx/store';
import {TranslateService} from '@ngx-translate/core';
import {GeneralSandbox, globalActions, GlobalErrorHandler, NotificationEnum, NotificationService, NotificationTimes, utils} from '../modules/global';
import {environment} from '../environments/environment';
import {Subject} from 'rxjs';
import {switchMap, takeUntil} from 'rxjs/operators';
import { MainContainer } from './containers/main/main.container';

/**
 * App Component
 */

@Component({
    selector: 'slm-root',
    template: '<slm-main></slm-main>',
    imports: [MainContainer]
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly store = inject(Store);
  private readonly translateService = inject(TranslateService);
  private readonly globalErrorHandler = inject(GlobalErrorHandler);
  private readonly generalSandbox = inject(GeneralSandbox);
  private readonly notification = inject(NotificationService);

  private destroy$ = new Subject();

  ngOnInit() {
    this.store.dispatch(globalActions.setLanguage({language: this.translateService.currentLang}));
    if(environment.errorReload) {
      const error = this.globalErrorHandler.getError();
      const isChunkError = this.globalErrorHandler.isChunkError();

      if (!!error) {
        if(!isChunkError){
          this.generalSandbox.sendError(error).subscribe();
        }
        this.globalErrorHandler.clearError();
        this.notification.notify(
          'MESSAGE.CONSOLE_ERROR_DETECTED',
          NotificationEnum.WARNING,
          NotificationTimes.INFINITE);
      }

      if(isChunkError){
        this.notification.notify('MESSAGE.NEED_TO_REFRESH', NotificationEnum.WARNING, NotificationTimes.INFINITE);
      }else{
        this.globalErrorHandler.errorReporter$.pipe(
          switchMap((error) => {
            this.notification.notify(error.message, NotificationEnum.WARNING, NotificationTimes.INFINITE);
            return this.generalSandbox.sendError(utils.isObject(error.error) ? JSON.stringify(error.error) : error.error);
          }),
          takeUntil(this.destroy$)).subscribe();
      }
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
